<template>
  <v-app id="inspire">
    <v-app-bar
      absolute
      color="white"
    >
      <v-toolbar flat>
        <v-app-bar-nav-icon v-show="$vuetify.breakpoint.width<1024" @click="drawer = true"></v-app-bar-nav-icon>
        <v-card flat to="/">
          <v-img class="" :src="require('@/assets/images/logo.png')" width="200"></v-img>
        </v-card>
      </v-toolbar>

      <!--
      <v-btn fixed tile text retain-focus-on-click plain class="justify-start pa-0 ml-10" to="/">
        <v-img :src="require('@/assets/images/logo.png')" width="200" />
      </v-btn>
      -->
      <v-spacer></v-spacer>
      <v-container class="py-0 fill-height justify-end" v-show="$vuetify.breakpoint.width>1024" >
        <v-menu
          offset-y
          open-on-hover
          v-for="(title, i) in titles"
          :key="i"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              text
              v-bind="attrs"
              v-on="on"
              width="155"
            >
              {{title}}
            </v-btn>
          </template>
          <v-list>
            <v-list-item
              v-for="(menu, index) in menus[i]"
              :key="index"
              :to="`?menu=${i+1}&page=${menu.page}`"
              color="white"
            >
              <v-list-item-title class="black--text">{{ menu.title }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-container>
    </v-app-bar>

    <v-navigation-drawer
      v-model="drawer"
      absolute
      temporary
    >
      <v-list
        nav
        dense
      >
        <v-list-item-group
          active-class="deep-purple--text text--accent-4"
        >
        <v-list>
            <v-list-group
              v-for="(item, i) in titles" :key="i"
              :value="false"
              no-action
              sub-group
            >
              <template v-slot:activator>
                <v-list-item-content>
                  <v-list-item-title>{{item}}</v-list-item-title>
                </v-list-item-content>
              </template>

              <v-list-item
                v-for="(menu, index) in menus[i]"
                :key="index"
                link
                :to="`?menu=${menu.menuno}&page=${menu.page}`"
              >
                <v-list-item-title>
                  <span>{{ menu.title }}</span>
                </v-list-item-title>
              </v-list-item>
            </v-list-group>
        </v-list>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>

    <v-main style="padding: 56px 0px 0px;">
      <router-view :key="$route.fullPath"/>
    </v-main>

    <v-footer
      color="grey darken-3"
      padless
    >
      <v-col cols="12" sm="3" >
        <v-card class="d-flex justify-center align-center grey darken-3" outlined tile>
          <v-img class="" :src="require('@/assets/images/footerinfinity.png')" max-width="250"></v-img>
        </v-card>
      </v-col>
      <v-col cols="12" sm="9">
        <v-row
          justify="start"
          no-gutters
        >
          <div>
            <!--
            <v-btn
              v-for="(link, i) in footer"
              :key="i"
              color="white"
              text
              rounded
              plain
              class="my-2"
              :to="link.page"
            >
              {{ link.title}}
            </v-btn>
            -->
            <v-card class="d-flex grey darken-3 pa-0" outlined tile height="110">
              <v-card-text class="white--text pa-2" style="font-size: 0.875rem; line-height:2rem ">
                인피니티투자자문(주) | 대표자 나홍규 | 사업자번호 104-81-69601 | TEL 02-784-7670 | FAX 02-784-7677<br>
                서울특별시 영등포구 국제금융로2길 32, 13층(여의도동, 여의도파이낸스타워) | E-MAIL contact@infinityasset.com<br>
                COPYRIGHT(C) 2020(주) 인피니티투자자문 ALL RIGHT RESERVICED
              </v-card-text>
            </v-card>
          </div>
        </v-row>

      </v-col>
    </v-footer>

  </v-app>
</template>


<script>
export default {
  name: 'App',
  created() {
    //console.log(this.$vuetify.breakpoint);
    //console.log(this.$vuetify.breakpoint.width)
  },
  data: () => ({
    menus: [
      [
        { title: '회사개요', menuno: '01', page: 'tab-1' },
        { title: '회사연혁', menuno: '01', page: 'tab-2' },
        { title: '경영철학', menuno: '01', page: 'tab-3' },
        { title: '조직도', menuno: '01', page: 'tab-4' },
        { title: '찾아오시는 길', menuno: '01', page: 'tab-5' }
      ],
       [
        { title: '운용상품', menuno: '02', page: 'tab-1' },
        { title: '투자일임업이란?', menuno: '02', page: 'tab-2' },
        { title: '서비스 과정', menuno: '02', page: 'tab-3' },
        { title: '인피니티의 강점', menuno: '02', page: 'tab-4' }
      ],
      [
        { title: '운용철학', menuno: '03', page: 'tab-1' },
        { title: '운용프로세스', menuno: '03', page: 'tab-2' },
        { title: '리스크관리', menuno: '03', page: 'tab-3' },
        { title: '컴플라이언스', menuno: '03', page: 'tab-4' }
      ],
      [
        { title: 'CEO', menuno: '04', page: 'tab-1' },
        { title: '운용본부', menuno: '04', page: 'tab-2' },
        { title: 'AI본부', menuno: '04', page: 'tab-3' },
        { title: '고객자산본부', menuno: '04', page: 'tab-4' },
        { title: '경영본부', menuno: '04', page: 'tab-5' }
      ],
      [
        { title: '인피니티 소식', menuno: '05', page: 'tab-1' },
      ],
    ],
    titles: [
      '회사소개',
      '운용상품 및 서비스',
      '운용시스템',
      '인피니티 사람들',
      '인피니티 소식'
    ],
/*
    footer: [
        { title: '회사소개', page: 'menu01?page=tab-1', },
        { title: '운용상품 및 서비스', page: 'menu02?page=tab-2', },
        { title: '운용시스템', page: 'menu03?page=tab-1', },
        { title: '인피니티 사람들', page: 'menu04?page=tab-1', },
        { title: '공지사항', page: 'menu05?page=tab-1', },
    ],
*/
    drawer: false,
    group: null,
    search: null
  }),
  watch: {
    group () {
      this.drawer = false;
    },
  },
  mounted() {
    //console.log(process.env.VUE_APP_API_URL);
  },
  methods: {
    goPage(menuno){
      console.log(menuno);
    }
  }
};
</script>

<style>
/*
.v-toolbar__content, .v-toolbar__extension {
  float: right !important;
}
*/
</style>